import { render } from "./BettingRules.vue?vue&type=template&id=436a3181&scoped=true"
import script from "./BettingRules.vue?vue&type=script&lang=js"
export * from "./BettingRules.vue?vue&type=script&lang=js"

import "./BettingRules.vue?vue&type=style&index=0&id=436a3181&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-436a3181"

export default script